import { tv } from '@/common/theme/tv.config';

export const styles = {
  content: 'w-full h-full relative overflow-hidden',
  circle: tv({
    base: 'absolute bottom-full right-1/2 h-[160rem] w-[160rem] translate-x-[50%] rounded-full bg-accentSecondary20 sm:bottom-0 sm:right-0',
    variants: {
      size: {
        md: 'translate-y-[34.4rem] sm:translate-x-[74%] sm:translate-y-[24%]',
        lg: 'bottom-[30%] sm:translate-x-[74%] sm:translate-y-[24%]',
      },
    },
  }),
  steps:
    'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 sm:relative sm:left-0 sm:top-0 sm:-translate-x-0 sm:-translate-y-0',
  step: tv({
    base: 'h-xs rounded-full bg-neutral40',
    variants: {
      active: {
        true: 'rounded-xs bg-accentSecondary40',
      },
    },
  }),
  header: 'sm:px-2xl',
  footer: 'sm:px-2xl sm:pt-0',
};
